/** @flow */
import React from 'react'
import type { AssetTypes, ID } from 'app/core/types'
import pipe from 'app/core/utils/pipe'
import type { Pipe } from 'app/core/utils/pipeNext.type'
import { assetIcons } from 'app/components/Icons/assetsIcons'
import resources from 'app/store/resources'
import { Breadcrumbs, Link, styled } from '@mui/material'
import classes from 'app/components/Breadcrumb/Breadcrumb.module.scss'
import FontIcon from 'app/components/FontIcon/FontIcon.jsx'

export type BreadcrumbsProps = {|
  classes: Object,
  className: string,
  disableClickItem?: boolean,
  breadcrumb: Array<{|
    id: string,
    name: string,
    assetType?: AssetTypes,
    parent: string,
  |}>,
  onClick?: Function,
|}

const StyledBreadcrumbs = styled((props) => <Breadcrumbs {...props} />)((props) => {
  const { theme } = props
  return {
    '&.MuiBreadcrumbs-root': {
      padding: `${theme.spacing(1)}px 10px ${theme.spacing(1)}px 0px`,
      maxWidth: '100%',
      overflow: 'hidden',
      '&>nav>ol': {
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap',
      },
    },
  }
})

function MuiBreadcrumbs(props: BreadcrumbsProps) {
  const { onClick, disableClickItem, className, breadcrumb } = props

  return (
    <div className={className}>
      <StyledBreadcrumbs arial-label="Breadcrumb" itemsAfterCollapse={2} itemsBeforeCollapse={1} maxItems={5}>
        {breadcrumb.map((asset, index) => {
          return (
            <Link
              key={asset.parent}
              className={classes.breadcrumbLink}
              color="inherit"
              onClick={() => {
                !disableClickItem && onClick && onClick(asset)
              }}
            >
              {asset.assetType && <FontIcon className={classes.icon} icon={assetIcons(asset.assetType)} />} {asset.name}
            </Link>
          )
        })}
      </StyledBreadcrumbs>
    </div>
  )
}

const pipeInst: Pipe<
  {
    asset: Object,
    fullpath?: boolean,
    startAtAssetId?: ID,
  },
  typeof StyledBreadcrumbs,
> = pipe()

export const Breadcrumb: React$ComponentType<any> = pipeInst
  .withRouter()
  .connect((state, props) => {
    let { asset } = props
    const { location } = props

    const splitedPath = location.pathname.split('/')

    const isUnderProject = splitedPath[1] === 'projects' && !!splitedPath[2]

    const breadcrumb = []

    while (asset) {
      if (isUnderProject && asset.assetType === 'pj') break

      const parentAsset = asset.parent && state.assets.resources[asset.parent]
      breadcrumb.push(asset)
      asset = parentAsset
    }

    return {
      breadcrumb: breadcrumb.reverse(),
    }
  })
  .request((props) => {
    if (!props || !props.asset) return Promise.resolve()

    const { id, project, parent } = props.asset

    if (!parent) return Promise.resolve()

    return project ? resources.assets.fetchWithShortPath(id) : resources.assets.fetchWithFullPath(id)
  })
  .renderLoader(() => 'Loading...')
  .render(({ assetId, fullpath, ...rest }) => <MuiBreadcrumbs {...rest} />)
